import { Carousel, Row } from 'antd';
import BannerWidget from 'components/BannerWidget';
import { Viewport } from 'components/ViewportProvider';
import React, { FC, useMemo } from 'react';
import styled from 'styles/styled-components';
import { BannerItemUnion, ShowPopupBannerItem } from 'types/schema';
import { commonDimensions } from 'utils/constants';
import media from 'utils/mediaStyle';
import CategoryNav from '../../containers/CategoryNav';
import { Arrow as CarouselArrow } from './Arrow';
import NewCustomerBanner from './NewCustomerBannerEn.png';
import NewCustomerBannerVi from './NewCustomerBannerVI.png';
import { HeaderMarquee } from '../CategoryNav/desktopNewDesign';

const BannerSliderWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  @media (max-width: 767px) {
    left: 50%;
    transform: translateX(-50%);
  }

  .ant-carousel,
  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide > div {
    height: 100%;
  }
  @media (min-width: 577px) {
    &:hover {
      .ant-carousel .slick-slider .slick-arrow {
        display: flex;
      }
    }
  }

  .ant-carousel {
    .slick-slider {
      .slick-next,
      .slick-prev {
        background: #fff;
        z-index: 3;
        color: #595959;
        // filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
        border: 1px solid #ffffff;
        box-shadow: 2px 6px 32px 0 rgba(0, 0, 0, 0.10);
        font-size: 14px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translateY(-50%);
        opacity: 1;
        transition: opacity 0.2s ease;
         width: 39px !important;
        height: 39px !important;
        border-radius: 50%;
        cursor: pointer;
        display: none;
        &:after {
          display: none;
        }
        &:before {
          content: '';
        }
        svg {
          width: 16px;
        }
        &:hover {
          border: 1px solid #43A047 !important;
          svg {
            path {
              fill: #43A047;
            }
          }
        }
      }

      .slick-prev {
        left: 12px !important;
      }

      .slick-next {
        right: 12px !important;
      }
      @media (max-width: 576px) {
        .slick-prev,
        .slick-next {
          display: none;
        }
      }
  }
  .slick-slider {
    .slick-dots-bottom {
      bottom: 12px;
      @media (max-width: 991px) {
        bottom: 8px;
      }
    }

    .slick-prev {
      left: 0;
    }

    .slick-next {
      right: 0;
    }

    .slick-dots {
      li {
        margin: 0 4px;
        height: 10px !important;
        @media (max-width: 991px) {
          height: 4px !important;
          width: 4px !important;
        }
      }
      button {
        border-radius: 50%;
        width: 10px;
        height: 10px !important;
        opacity: 0.4 !important;
        @media (max-width: 991px) {
          width: 4px;
          height: 4px !important;
        }
      }
      li.slick-active button {
        width: 24px;
        height: 10px !important;
        opacity: 1 !important;
        border-radius: 80px !important;
        @media (max-width: 991px) {
          width: 12px;
          height: 4px !important;
          border-radius: 0px !important;
        }
      }
      li.slick-active:after {
        display: none !important;
      }
      li.slick-active {
        @media (max-width: 991px) {
          width: 12px !important;
        }
      }
    }
  }
`;

const ArrowWrapper = styled.div`
  box-shadow: 2px 6px 32px 0 rgba(0, 0, 0, 0.1);
`;

interface ArrowButtonProps {
  type: 'left' | 'right';
  className?: string;
  onClick?: () => void;
}

const Arrow = ({ type, className, onClick }: ArrowButtonProps) => (
  <ArrowWrapper
    onClick={onClick}
    className={className}
    style={{ transform: `rotate(${type === 'left' ? '180' : '0'}deg)` }}
  >
    <CarouselArrow />
  </ArrowWrapper>
);

interface IProps {
  banners: BannerItemUnion[];
  onOpenPopup: (modalData: ShowPopupBannerItem) => void;
}

const BannerSliderRowWrapper = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
  position: relative;
  padding: 0 40px;
  @media (min-width: 1024px) {
    margin: 20px auto 20px;
    display: grid;
    grid-template-columns: 230px 1fr;
    grid-template-rows: auto auto;
    column-gap: 16px;
  }
  #products-category {
    margin-top: 0px !important;
  }
  @media (max-width: 1023px) {
    padding: 20px 16px 24px;
    background: #f7f7f8;
  }
  @media (max-width: 991px) {
    padding: 16px 16px 8px;
  }
`;

const BannerSliderRow = styled(Row)`
  position: relative;
  @media (max-width: 767px) {
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      // height: 100px;
      left: 0;
      top: -65px;
      // background: rgb(76, 175, 80);
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;
    }
  }
  &.ant-row {
    padding-bottom: 32%;
    height: 0;
  }
  ${media.lg`
    &.ant-row {
      padding-bottom: 33.8%;
      width: 100%;
    }
  `};
`;

const MainSection = styled.div`
  overflow: hidden;
  grid-area: 1 / 2 / 3 / 3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto 0;
`;

const CategoryNavWrapper = styled.div`
  grid-area: 1/1/3/2;
`;

const BannerSlider: FC<IProps> = (props) => {
  const { banners, onOpenPopup } = props;
  const loginned = localStorage.getItem('token');
  const lang = localStorage.getItem('lang');
  const bannersValue = useMemo(() => {
    const bannerForNewCustomers = {
      imageUrl: lang === 'vi' ? NewCustomerBannerVi : NewCustomerBanner,
      type: 'GoToScreenBannerItem',
      screen: {
        name: 'ContactUs',
        title: 'CONTACT_US',
        filter: {
          urlInfo: {
            url: `${process.env.APP_URL}/contact-us`,
          },
          filterType: 'URL',
        },
        sort: [],
      },
    };
    if (!loginned) {
      banners.unshift(bannerForNewCustomers);
    }
    return banners;
  }, [banners]);

  return (
    <Viewport.Consumer>
      {({ width }) => (
        <BannerSliderRowWrapper>
          {width > 1023 && (
            <CategoryNavWrapper>
              <CategoryNav />
            </CategoryNavWrapper>
          )}
          <MainSection>
            <BannerSliderRow>
              <BannerSliderWrapper>
                <Carousel
                  draggable
                  autoplay
                  autoplaySpeed={5000}
                  dots
                  arrows
                  nextArrow={<Arrow type="right" />}
                  prevArrow={<Arrow type="left" />}
                >
                  {bannersValue.map((banner, index) => (
                    <BannerWidget key={index.toString()} banner={banner} onOpenPopup={onOpenPopup} />
                  ))}
                </Carousel>
              </BannerSliderWrapper>
            </BannerSliderRow>
          </MainSection>
          {width < 1024 && <HeaderMarquee />}
        </BannerSliderRowWrapper>
      )}
    </Viewport.Consumer>
  );
};

export default BannerSlider;
